import { z } from 'zod'

// Schéma partagé du formulaire marque (validation Zod, sans dépendance à react-hook-form).
export const zBrandForm = z.object({
  image: z.instanceof(File).nullable(),
  name: z.string().nonempty().max(30),
})

export type BrandForm = z.infer<typeof zBrandForm>
